import { MessageResponse, QueryParams } from "../common/types/apiTypes";
import { Options } from "../common/types/requestOptions";
import { messageApi } from "./api";
import { ApiError } from "./error";

export const queryMsg = async <
  TFilters extends QueryParams, // filter type
  TResponse, // return type
>(
  endpoint: string,
  filters: TFilters,
  options: Options = {},
): Promise<MessageResponse<TResponse>> => {
  const res = await messageApi.get<MessageResponse<TResponse>>(endpoint, {
    requestId: options.requestId,
    queryParams: {
      ...filters,
    },
    auth: true,
  });

  if (!res.data.success) {
    throw new ApiError(res.status, res.data.error || 'internal_error');
  }

  return res.data;
};
